import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import AddToStudiesModal from 'studies/studyable/AddToStudiesModal';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import legacyRunModal from 'ui-library/legacyRunModal';

export interface AddToStudiesButtonProps {
  itemIds: Array<string>;
  buttonStyle?: ButtonStyle;
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  showText?: boolean;
  tooltipTitleWhenDisabled?: string | null;
}

export default function AddToStudiesButton({
  itemIds,
  buttonStyle = ButtonStyle.TERTIARY_BLUE,
  className,
  disabled,
  fullWidth,
  showText,
  tooltipTitleWhenDisabled,
}: AddToStudiesButtonProps): JSX.Element {
  return (
    <Tooltip
      text={disabled ? tooltipTitleWhenDisabled : 'Add to studies'}
      isDisabled={disabled && tooltipTitleWhenDisabled == null}
    >
      <Button
        aria-label={showText ? undefined : 'Add to studies'}
        buttonStyle={buttonStyle}
        className={className}
        disabled={disabled}
        fullWidth={fullWidth}
        icon={ModelTypeConstants.STUDY}
        onClick={() => {
          legacyRunModal(AddToStudiesModal, {itemIds});
        }}
        size={ButtonSize.SMALL}
        text={showText ? 'Add to studies' : null}
      />
    </Tooltip>
  );
}
